import { forwardRef, useCallback } from 'react';
import { styled } from '@mui/material/styles';
import { useSnackbar, SnackbarContent, CustomContentProps } from 'notistack';
import Typography from '@mui/material/Typography';
import { Card, CardHeader, CardContent, CardActions } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import InactiveSubscription, { descriptions } from '../../pages/User/InactiveSubscription';

const PREFIX = 'Layout';

export const subscriptionTypesMessage = [
	{
		id: 1,
		label: 'either premium or premium plus'
	},
	{
		id: 2,
		label: 'premium plus'
	}
];

const classes = {
	card: `${PREFIX}-root`,
	typography: `${PREFIX}-content`,
	actionRoot: `${PREFIX}-actionRoot`,
	icons: `${PREFIX}-icons`,
	expand: `${PREFIX}-expand`,
	expandOpen: `${PREFIX}-expandOpen`,
	paper: `${PREFIX}-paper`,
	checkIcon: `${PREFIX}-checkIcon`,
	button: `${PREFIX}-button`
};

const StyledSnackbarContent = styled(SnackbarContent)(() => ({
	'@media (min-width:600px)': {
		left: 0
	},
	[`& .${classes.card}`]: {
		color: '#fff',
		width: '100%',
		backgroundColor: '#496B8C'
	},
	[`& .${classes.typography}`]: {
		color: '#000'
	},
	[`& .${classes.actionRoot}`]: {
		padding: '8px 8px 8px 16px',
		justifyContent: 'space-between'
	},
	[`& .${classes.icons}`]: {
		marginLeft: 'auto'
	},
	[`& .${classes.expand}`]: {
		color: '#fff'
	},
	[`& .${classes.paper}`]: {
		backgroundColor: '#fff',
		padding: 16
	},
	[`& .${classes.checkIcon}`]: {
		fontSize: 20,
		paddingRight: 4
	},
	[`& .${classes.button}`]: {
		padding: 0,
		textTransform: 'none'
	}
}));

const PremiumPlusSnackbar = forwardRef(
	({ id, subscriptionTypesMessage, subscriptionLinkTitle, fontColor, ...props }, ref) => {
		const { closeSnackbar } = useSnackbar();

		const handleDismiss = useCallback(() => {
			closeSnackbar(id);
		}, [id, closeSnackbar]);

		return (
			<StyledSnackbarContent ref={ref}>
				<Card className={classes.card}>
					<CardHeader
						action={
							<IconButton size="small" className={classes.expand} onClick={handleDismiss}>
								<CloseIcon fontSize="small" />
							</IconButton>
						}
						title={
							<Typography component="span" variant="h6" fontWeight={'bold'}>
								{props.message}
							</Typography>
						}
					></CardHeader>
					<CardContent>
						<InactiveSubscription
							displayInformativeText={true}
							titleText={<strong>Cont Premium</strong>}
							description={
								subscriptionTypesMessage?.id
									? descriptions[subscriptionTypesMessage?.id]
									: descriptions[2]
							}
							fontColor={fontColor}
							benefitsLinkPath="/profil/premium"
							subscriptionsLinkPath="/profil"
							subscriptionLinkTitle={subscriptionLinkTitle ? subscriptionLinkTitle : 'Schimbă'}
						/>
					</CardContent>
				</Card>
			</StyledSnackbarContent>
		);
	}
);

PremiumPlusSnackbar.displayName = 'PremiumPlusSnackbar';

export default PremiumPlusSnackbar;
